function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "spark");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "desktop-design",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "desktop-sign-up-tooltip",
  transform: "translate(-624.000000, -25.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "spark",
  transform: "translate(624.000000, 25.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M76.9003014,146.282168 L8.89410709,160.068372 C2.82918981,161.517702 -1.00206888,167.534016 0.230339322,173.673287 C1.46274753,179.812557 7.31560986,183.866909 13.4656346,182.841544 L81.4970164,169.051123 C85.6165863,168.301055 89.0109846,165.372878 90.3718106,161.395285 C91.7326367,157.417692 90.847383,153.011826 88.0572784,149.875966 C85.2671738,146.740106 81.0079227,145.363951 76.9212909,146.277951 L76.9003014,146.282168 Z",
  id: "Path",
  fill: "#F37021"
}), /*#__PURE__*/React.createElement("path", {
  d: "M95.7661341,97.9554517 L37.9692256,59.917622 C32.6503262,56.4140398 25.4717896,57.8457835 21.9355154,63.1155111 C18.3992412,68.3852386 19.8443445,75.4974115 25.163244,79.0009937 L82.9601524,117.034665 C86.4000884,119.338622 90.8227469,119.638428 94.5473634,117.820147 C98.27198,116.001867 100.726693,112.34467 100.978626,108.238419 C101.23056,104.132168 99.2410324,100.207319 95.7661341,97.9554517 L95.7661341,97.9554517 Z",
  id: "Path",
  fill: "#FDB714"
}), /*#__PURE__*/React.createElement("path", {
  d: "M128.992929,9.58283594 C128.295571,5.4488536 125.380118,2.02064017 121.387961,0.640332006 C117.395804,-0.739976156 112.962092,0.147226646 109.822611,2.95460289 C106.68313,5.76197914 105.337369,10.042878 106.312189,14.121339 L120.042437,81.5743206 C120.789461,85.660379 123.705753,89.0271647 127.667201,90.3769208 C131.62865,91.7266769 136.016634,90.8486245 139.139766,88.0812166 C142.262898,85.3138088 143.633468,81.0892056 142.723177,77.0358176 L128.992929,9.58283594 Z",
  id: "Path",
  fill: "#D92632"
}), /*#__PURE__*/React.createElement("path", {
  d: "M189.971139,95.9012713 L228.007751,38.0825922 C230.332329,34.6424543 230.645351,30.2064319 228.827288,26.4684242 C227.009226,22.7304164 223.340811,20.2676204 219.222831,20.0204571 C215.104852,19.7732937 211.173178,21.7799282 208.929122,25.2741253 L170.867549,83.1012035 C167.423689,88.4222089 168.876954,95.5512434 174.122266,99.0673164 C179.367579,102.583389 186.44055,101.169717 189.962819,95.9012713 L189.971139,95.9012713 Z",
  id: "Path",
  fill: "#F37021"
}), /*#__PURE__*/React.createElement("path", {
  d: "M287.774262,115.297092 C286.512726,109.025289 280.448249,104.967942 274.221868,106.230067 L206.60598,119.977797 C202.462013,120.676042 199.02552,123.595207 197.641878,127.592447 C196.258237,131.589687 197.147582,136.029044 199.961739,139.172522 C202.775895,142.316 207.067133,143.663475 211.155444,142.687413 L278.771332,128.939684 C284.991703,127.670361 289.018919,121.567717 287.774262,115.297092 L287.774262,115.297092 Z",
  id: "Path",
  fill: "#FDB714"
}), /*#__PURE__*/React.createElement("path", {
  d: "M262.83029,209.994728 L204.982793,171.916587 C199.657304,168.412358 192.472381,169.8481 188.934819,175.123409 C185.397256,180.398717 186.846655,187.515938 192.172143,191.020169 L250.032245,229.085823 C255.354253,232.586605 262.533533,231.150863 266.067615,225.879002 C269.601698,220.607142 268.152298,213.49551 262.83029,209.994728 L262.83029,209.994728 Z",
  id: "Path",
  fill: "#D92632"
}))));

var SvgSpark = function SvgSpark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "288px",
    height: "231px",
    viewBox: "0 0 288 231",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSpark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/spark.4baebbce.svg";
export { ForwardRef as ReactComponent };